import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { QueryClientProvider } from '@tanstack/react-query'
import { ThemeProvider } from './contexts/ThemeContext'
import { AuthProvider } from './contexts/AuthContext'
import { queryClient } from './lib/queryClient'
import { setupDeepLinkHandler } from './lib/capacitorAuth'
import { initNativePlugins, initWebKeyboardHandling } from './lib/capacitorInit'
import { initSentry } from './lib/sentry'
import { initLifecycle } from './lib/lifecycle'
import { pruneOldCaches } from './utils/scoreQueue'
import App from './App.jsx'
import './index.css'

// Initialize Sentry before anything else
initSentry()

// Track app pause/resume transitions so Sentry events get tagged with
// resumeRelated and Watchdog L can read lastResumeAt
initLifecycle()

// Evict cache entries older than 30 days so localStorage doesn't grow unbounded
pruneOldCaches()

// Initialize deep link handler for Capacitor OAuth callbacks
setupDeepLinkHandler()

// Initialize native plugins (StatusBar, Keyboard, SplashScreen)
initNativePlugins()

// Initialize web keyboard handling (visualViewport-based)
initWebKeyboardHandling()

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <ThemeProvider>
      <QueryClientProvider client={queryClient}>
        <AuthProvider>
          <App />
        </AuthProvider>
      </QueryClientProvider>
    </ThemeProvider>
  </StrictMode>,
)
